
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Brain } from 'lucide-react';
import { TaxonomyLevel } from '@/types/supabase';
import { useReflection } from './hooks/useReflection';
import ExistingReflection from './components/ExistingReflection';
import ReflectionForm from './components/ReflectionForm';
import ReflectionPrompt from './components/ReflectionPrompt';
import { taxonomyColors } from './constants/reflectionPrompts';

type TaxonomyReflectionProps = {
  moduleId: string;
  lessonId?: string;
  taxonomyLevel: TaxonomyLevel;
};

export const TaxonomyReflection: React.FC<TaxonomyReflectionProps> = ({ 
  moduleId, 
  lessonId, 
  taxonomyLevel 
}) => {
  const {
    reflectionText,
    setReflectionText,
    isSubmitting,
    existingReflection,
    showForm,
    setShowForm,
    submitReflection
  } = useReflection(moduleId, taxonomyLevel, lessonId);

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="flex items-center">
          <Brain className={`mr-2 h-5 w-5 ${taxonomyColors[taxonomyLevel]}`} />
          {taxonomyLevel.charAt(0).toUpperCase() + taxonomyLevel.slice(1)} Reflection
        </CardTitle>
        <CardDescription>
          Reflect on your learning at the {taxonomyLevel} level of Bloom's Taxonomy
        </CardDescription>
      </CardHeader>
      <CardContent>
        {existingReflection && !showForm ? (
          <ExistingReflection 
            existingReflection={existingReflection} 
            setShowForm={setShowForm} 
          />
        ) : (
          <div className="space-y-4">
            <ReflectionPrompt taxonomyLevel={taxonomyLevel} />
            <ReflectionForm
              reflectionText={reflectionText}
              setReflectionText={setReflectionText}
              submitReflection={submitReflection}
              isSubmitting={isSubmitting}
              existingReflection={existingReflection}
              setShowForm={setShowForm}
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TaxonomyReflection;
